import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MobilePopupService} from '../../../services/mobile-popup/mobile-popup.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-component-button-more',
    templateUrl: './button-more.component.html',
    styleUrls: ['./button-more.component.scss'],
    animations: [
        trigger('fade', [
            state('in', style({opacity: 1, 'margin-top': '0px'})),
            transition(':enter', [style({opacity: 0, 'margin-top': '-15px'}), animate('0.1s ease-out')]),
            transition(':leave', animate('0.1s ease-out', style({opacity: 0, 'margin-top': '-15px'})))
        ])
    ]
})
export class ButtonMoreComponent implements OnInit, OnDestroy {

    public open = false;
    public stylize = [];
    public mobile = window.innerWidth <= 767;
    @Input('variables') public vars: any;
    @Input('hidden') public hidden = false;
    @Input('customization') public customization: object = null;
    @Input('iconColor') public iconColor = '#808080';
    @Input('position') public position = 'center';
    @Input('bold') public bold = false;
    @Input() public isTaskStatus = false;
    isHideBackStatus = true;
    private subscription: Subscription = new Subscription();
    @Output('answer') private answer: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('opener') private opener: ElementRef;

    constructor(private mobilePopup: MobilePopupService) {
    }

    @HostListener('document:click', ['$event'])
    AfterClick(event): void {
        /* if (this.open
            && this.opener
            && !this.opener.nativeElement.contains(event.target)
        ) {
        } else if (this.mobile && this.open && this.opener && this.opener.nativeElement.contains(event.target)) {
            this.openMobile();
        } */
    }

    ngOnInit(): void {
        if (this.customization) {
            for (const key of Object.keys(this.customization)) {
                this.stylize[key] = this.customization[key];
            }
        }
        this.stylize['z-index'] = 1002;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    setAnswer(key): void {
        this.answer.emit(key);
    }

    openMobile(): void {
        // this.mobilePopup.openPopup(this.vars);
        // this.subscription = this.mobilePopup.answer.subscribe(data => {
        //     this.setAnswer(data);
        //     this.subscription.unsubscribe();
        // });
    }
}
